export function getAboutPage({ about }) {
  return about.about;
}

export function getPages({ about }) {
  return about.pages;
}
